const MobileDetect = require('mobile-detect');

export class DeviceService {
  isMobile(): boolean {
    const md = new MobileDetect(window.navigator.userAgent);
    
    return !!md.mobile();
  }
}